module.exports = __webpack_public_path__ + "static/media/check.fc280dfb.svg";